module.exports = __webpack_public_path__ + "img/b1d818f0-ff1f-4612-b586-62f75e14466c.0c6f5036.webp";